import { useEffect, useState } from 'react';
import { useLocation, useRouteError } from 'react-router';
import { extractErrorInfo, isVersionMismatchError, shouldAttemptReload } from './services';
import { ErrorPageTmpl } from './templates';

interface ErrorBoundaryProps {
  isUnderSubsystem?: boolean;
}

/**
 * should use within `GlobalContainer`
 */
export function ErrorBoundary(props: ErrorBoundaryProps) {
  const { pathname } = useLocation();
  const error = useRouteError();
  const [isReloading, setIsReloading] = useState(false);
  const [hasReloadFailed, setHasReloadFailed] = useState(false);

  useEffect(() => {
    if (!error) {
      return;
    }

    window.dispatchEvent(new CustomEvent('react-error', { detail: extractErrorInfo(error) }));

    if (isVersionMismatchError(error)) {
      if (shouldAttemptReload()) {
        setIsReloading(true);
        window.location.reload();
      } else {
        setHasReloadFailed(true);
      }
    }
  }, [error, pathname]);

  if (isReloading) {
    return (
      <ErrorPageTmpl title="ページ更新中" homePath={`/${pathname.split('/')[1]}/main-menu`} {...props}>
        新しいページを読み込んでいます...
        <br />
        <br />
        しばらくお待ちください。
        <br />
        <br />
      </ErrorPageTmpl>
    );
  }

  if (hasReloadFailed) {
    return (
      <ErrorPageTmpl title="ネットワークエラー" homePath={`/${pathname.split('/')[1]}/main-menu`} {...props}>
        ネットワークエラーが発生しました。
        <br />
        <br />
        ネットワーク接続を確認の上、再試行してください。問題が解決しない場合は、管理者にご連絡ください。
        <br />
        <br />
      </ErrorPageTmpl>
    );
  }

  if (error instanceof Error && isVersionMismatchError(error)) {
    return (
      <ErrorPageTmpl title="ネットワークエラー" homePath={`/${pathname.split('/')[1]}/main-menu`} {...props}>
        ネットワークエラーが発生しました。
        <br />
        <br />
        ページを再読み込みしてください。問題が解決しない場合は、管理者にご連絡ください。
        <br />
        <br />
      </ErrorPageTmpl>
    );
  }

  return (
    <ErrorPageTmpl title="システムエラー" homePath={`/${pathname.split('/')[1]}/main-menu`} {...props}>
      予期せぬエラーが発生しました。
      <br />
      <br />
      システム管理者にご連絡ください。
      <br />
      <br />
    </ErrorPageTmpl>
  );
}
